<template>
  <transition name="fade">
    <tr v-if="showLoadingIndicator" class="loading-row">
      <div v-if="!showLoadingFinishedIndicator">
        <span>Product upload successful. Loading drafts:</span>
        <span class="ml-15 loader-bar">
          <div />
        </span>
      </div>
      <div v-else>Loading complete</div>
    </tr>
  </transition>
</template>

<script>
import Pusher from "pusher-js";
export default {
  data() {
    return {
      showLoader: true,
      pusherChannel: `users_${this.$session.getUserInfo().id}`,
      pusher: null,
    };
  },
  computed: {
    showLoadingIndicator() {
      return this.$store.getters.draftStatus.started && this.showLoader;
    },
    showLoadingFinishedIndicator() {
      return this.$store.getters.draftStatus.ended;
    },
  },
  mounted() {
    const unsubscribe = this.$store.subscribe((mutation) => {
      if (mutation.type === "draftUploadEnded") {
        setTimeout(() => {
          this.$emit("upload-complete");
          unsubscribe();
          setTimeout(() => {
            this.showLoader = false;
            this.$store.commit("resetDraftLoader");
          }, 5000);
        }, 2000);
      }
    });
    this.pusher = new Pusher(this.$env.pusherOptions().key, this.$env.pusherOptions().options);
    this.pusher.subscribe(this.pusherChannel).bind("undefined error happened", ({ payload }) => {
      this.$swal(
        "Attention",
        "Your file contains unsupported characters. Please ensure your CSV file is UTF-8 encoded and try again."
      );
      this.showLoader = false;
      this.$store.commit("resetDraftLoader");
      this.$logger.notify(payload);
    });
  },
  beforeDestroy() {
    this.pusher.unsubscribe(this.pusherChannel);
    this.$store.commit("resetDraftLoader");
  },
};
</script>

<style scoped></style>
